import Loadable from "react-loadable";

const LazyEditPropale = Loadable({
  loader: () => import(/* webpackChunkName: 'propale-edit' */ "./edit"),
  loading: () => 'loading...'
});

export default LazyEditPropale;
